import parseJSON from 'date-fns/parseJSON';
import format from 'date-fns/format';

export function formatDateTime(dateTime, dateFormat) {
    return format(parseJSON(dateTime), dateFormat || 'dd/MM/yyyy HH:mm');
}
